import React from "react"
import Formsy from "formsy-react"
import types from "prop-types"
import { categoryShape } from "utils/propTypeShapes"
import { PrimaryButton } from "shared/buttons"
import * as API from "services/api"
import { useSubmit } from "hooks"
import { successToast, errorToast } from "shared/toast"
import CategoryName from "./CategoryName"
import CategoryDescription from "./CategoryDescription"
import CategoryUsageType from "./CategoryUsageType"

const GeneralTab = ({ category, setCategory }) => {
  const { canSubmit, enableSubmit, disableSubmit } = useSubmit()

  const updateCategory = async (model) => {
    const response = await API.updateCategory({
      categorySlug: category.slug,
      category: model,
    })
    if (response.ok) {
      setCategory({ ...category, ...model })
      successToast("Updated solution successfully!")
    } else {
      console.error("Error updating category: ", response)
      errorToast("Something went wrong. Unable to update solution.", response)
    }
  }

  return (
    <Formsy
      onSubmit={updateCategory}
      onValid={enableSubmit}
      onInvalid={disableSubmit}
      preventDefaultSubmit
    >
      <div className="tab-title">General</div>
      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-4">
          <CategoryName category={category} />
          <CategoryDescription category={category} />
          <CategoryUsageType category={category} />
        </div>
        <PrimaryButton
          className="w-full lg:max-w-max lg:self-center"
          text="Save Changes"
          type="submit"
          disabled={!canSubmit}
        />
      </div>
    </Formsy>
  )
}

GeneralTab.propTypes = {
  category: categoryShape.isRequired,
  setCategory: types.func.isRequired,
}

export default GeneralTab
